import { Component, createRef } from "react";
import { cloneElement } from "react";

type HoverPanelProps = {
    node: React.ReactElement;
    target: React.ReactElement;
    onVisible?: (node:HTMLElement) => void;
};

type HoverPanelStates = {
    isVisible: boolean;
    isHovered: boolean;
};

export class HoverPanelTemplate extends Component<HoverPanelProps, HoverPanelStates>{
    private nodeRef = createRef<HTMLElement>();

    constructor(props: HoverPanelProps){
        super(props);
        
        this.state = {
            isVisible: false,
            isHovered: false
        };
    }

    private set isVisible(a: boolean){
        this.setState({isVisible: a});
    }

    private get isVisible(): boolean{
        return this.state.isVisible;
    }

    private set isHovered(a: boolean){
        this.setState({isHovered: a});
    }

    private get isHovered(): boolean{
        return this.state.isHovered;
    }

    hide = (): void => {
        this.isVisible = false;
        this.isHovered = false;
    };

    private tryHide = (): void => {
        setTimeout(() => {
            if(this.isHovered){
                return;
            }
            this.hide();
        }, 100);
    };

    private onNodeMouseEnter = (): void => {
        this.isVisible = true;;
        (this.props.onVisible || (() => {}))(this.nodeRef.current!)
    };

    private onNodeMouseLeave = (): void => {
        this.tryHide();
    };

    private onMouseEnter = (): void => {
        this.isHovered = true;
    };

    private onMouseLeave = (): void => {
        this.hide();
    };

    render(){
        return <>
            {cloneElement(this.props.node, {onMouseEnter: this.onNodeMouseEnter, onMouseLeave: this.onNodeMouseLeave, ref: this.nodeRef})}
            {this.isVisible && cloneElement(this.props.target, {onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave})}
        </>;
    }
}